import React from "react";
import { useTranslation } from "react-i18next";

interface LuigisboxAutocompleteTrendingBlockProperties {
    readonly trendingQueries: string[];
    readonly onTermClick: (term: string) => void;
}

export default function LuigisboxAutocompleteTrendingBlock({
    trendingQueries,
    onTermClick,
}: LuigisboxAutocompleteTrendingBlockProperties): React.JSX.Element | undefined {
    const { t } = useTranslation("header");

    if (trendingQueries.length === 0) {
        return undefined;
    }

    return (
        <div className="autocomplete-trending">
            <div className="autocomplete-section">
                <span>{t("trendingSearchQueries")}</span>
            </div>
            <div className="autocomplete-results autocomplete-results-trending">
                {trendingQueries.map((trendingQuery) => (
                    <a
                        className="autocomplete-trending-link"
                        href={`/vyhledavani?q=${encodeURIComponent(trendingQuery)}`}
                        key={trendingQuery}
                        onClick={() => onTermClick(trendingQuery)}
                    >
                        {trendingQuery}
                    </a>
                ))}
            </div>
        </div>
    );
}
